
import axios from '@/service/request';
import type { R } from './types';

export interface BookCarRequest {
  /**
   * 租车/包车类型, 参见枚举类: BookCarTypeEnum
   */
  bookCarType?: string;
  /**
   * 用户id
   */
  buyerId?: string;
  /**
   * 车辆需求
   */
  carRequirementInfo?: CarRequirementInfo;
  /**
   * 送客信息
   */
  dropoffInfo?: PassengerDropoffInfo;
  /**
   * 个人信息
   */
  personalInfo?: PersonalInfo;
  /**
   * 取车信息
   */
  pickupInfo?: PickupInfo;
  /**
   * 还车信息
   */
  returnInfo?: ReturnInfo;
  [property: string]: any;
}

/**
* 车辆需求
*
* CarRequirementInfo
*/
export interface CarRequirementInfo {
  /**
   * 车型. 参见枚举类: CarTypeEnum
   */
  carType?: string;
  /**
   * 行李件数
   */
  luggageCount?: number;
  /**
   * 乘客人数
   */
  passengerCount?: number;
  /**
   * 特殊需求，如儿童座椅、婴儿提篮等
   */
  specialRequirement?: string;
  [property: string]: any;
}

/**
* 送客信息
*
* PassengerDropoffInfo
*/
export interface PassengerDropoffInfo {
  /**
   * 送客地点
   */
  dropoffLocation?: string;
  /**
   * 预计行驶公里数
   */
  estimatedDistance?: string;
  /**
   * 预计用车时常
   */
  estimatedDuration?: string;
  [property: string]: any;
}

/**
* 个人信息
*
* PersonalInfo
*/
export interface PersonalInfo {
  /**
   * 电子邮箱
   */
  email?: string;
  /**
   * 姓名
   */
  name?: string;
  /**
   * 联系电话
   */
  phone?: string;
  [property: string]: any;
}

/**
* 取车信息
*
* PickupInfo
*/
export interface PickupInfo {
  /**
   * 取车日期
   */
  pickupDate?: string;
  /**
   * 取车地点
   */
  pickupLocation?: string;
  /**
   * 取车时间
   */
  pickupTime?: string;
  [property: string]: any;
}

/**
* 还车信息
*
* ReturnInfo
*/
export interface ReturnInfo {
  /**
   * 还车日期
   */
  returnDate?: string;
  /**
   * 还车地点
   */
  returnLocation?: string;
  /**
   * 还车时间
   */
  returnTime?: string;
  [property: string]: any;
}


export const apiBookCar = (data: BookCarRequest): Promise<R<boolean>> => {
  return axios.post('/order/bookCar', data);
};

